export default __webpack_public_path__ + "static/media/scan-qr.6d7a5d61.svg";